import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { North, Popup } from '../../utils/popups';
import { AudioDeviceList, VideoDeviceList } from '../DeviceList';
import { AbstractPopup } from './AbstractPopup';
export function DevicePopup({ kind, reject, resolve, ...props }) {
    return (_jsxs(DevicePopupRoot, { reject: reject, translateFn: North, ...props, children: [kind === 'audio' && (_jsx(AudioDeviceList, { onDeviceSelect: () => {
                    setTimeout(() => {
                        resolve();
                    }, 200);
                } })), kind === 'video' && (_jsx(VideoDeviceList, { onDeviceSelect: () => {
                    setTimeout(() => {
                        resolve();
                    }, 200);
                } }))] }));
}
const DevicePopupRoot = styled(AbstractPopup) `
    --Popup_Left: 50%;
    --Popup_Top: 50%;
    --Popup_X: -50%;
    --Popup_Y: -50%;
    --Popup_InitialOffsetY: 1rem;
    --Popup_OffsetY: 0;
    --Popup_Background: none;
    --Popup_Border: 0;
    --Popup_Padding: 0;
    --Popup_BorderRadius: 1rem;

    --Popup_Width: 20.75rem;
    --Popup_MaxWidth: calc(var(--vw-100, 100vh) - 2rem);

    @media (min-width: 30rem) {
        --Popup_InitialOffsetX: -50%;
        --Popup_InitialOffsetY: -100%;
        --Popup_OffsetY: calc(-100% - 1rem);
        --Popup_X: max(calc(50% + 1rem), var(--Popup_AnchorX, 0rem));

        --Popup_Left: 0;
        --Popup_Top: 0;
        --Popup_Y: initial;

        /* Setup */
        --Popup_InitialScale: 0.98;
    }
`;
const devicePopup = Popup.create(DevicePopup);
export function selectDevice(kind, options = {}) {
    (async () => {
        try {
            options.onOpenPopup?.();
            await devicePopup.pop({ kind, anchorRef: options.anchorRef });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    })();
}
